import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { InputBase } from '@mui/material';
import searchIcon from '../../../assets/images/searchIcon.svg';
import * as styles from './SearchInput.module.css';
const DELAY_TIME = 500;
export const SearchInput = ({ initSearchText, onSearch, }) => {
    const intl = useIntl();
    const [searchValue, setSearchValue] = useState(initSearchText);
    /** Нужен чтобы предотвратить лишний вызов onSearch при первой */
    const isFirstRender = useRef(true);
    const delayedSearch = useCallback((searchQuery) => {
        const handle = setTimeout(() => {
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            onSearch(searchQuery);
        }, DELAY_TIME);
        return () => clearTimeout(handle);
    }, [onSearch]);
    useEffect(() => {
        const delay = delayedSearch(searchValue);
        return delay;
    }, [searchValue, delayedSearch]);
    return (_jsxs("div", { className: styles.searchWrapper, children: [_jsx(InputBase, { className: styles.searchInput, placeholder: intl.formatMessage({ id: 'searchPlaceholder' }), value: searchValue, onChange: (e) => setSearchValue(e.target.value) }), _jsx("img", { src: searchIcon, alt: 'search icon' })] }));
};
